<template>
  <div
    class="
      p-6
      mx-auto
      max-w-4xl
      fixed
      top-16
      left-72
      right-0
      z-50
      overflow-hidden
      card
      shadow-2xl
      bg-base-100
      modal-box
      mb-4
      bg-gradient-to-bl
      from-blue-400
      to-blue-200
    "
  >
    <div class="card-body relative">
      <div
        @click="close"
        class="
          cursor-pointer
          absolute
          top-0
          right-0
          mr-10
          transform
          translate-x-9
          -translate-y-2
        "
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-6 w-6"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"
          />
        </svg>
      </div>
      <div
        class="flex items-center justify-center"
        v-if="data[i].proformaId === null"
      >
        <div class="flex flex-col items-center justify-center gap-5">
          <img
            src="../../../assets/bill.png"
            class="h-40"
            alt="profroma sitra"
          />
          <h3 class="text-2xl font-sans font-bold text-blue-900">
            You'r Profroma is beeing Generated, Please Wait a few days.
          </h3>
        </div>
      </div>
      <div v-else>
        <div class="grid grid-cols-3 gap-3">
          <div class="form-control">
            <label class="label">
              <span
                class="
                  label-text
                  font-bold
                  tracking-tight
                  leading-tight
                  text-white
                "
                >Profroma ID</span
              >
            </label>
            <div class="flex items-center">
              <input
                :value="data[i].proformaId"
                type="text"
                class="
                  input input-bordered
                  w-full
                  border-theme-green
                  focusring
                  input-sm
                "
                readonly
              />
            </div>
          </div>

          <div class="form-control">
            <label class="label">
              <span
                class="
                  label-text
                  font-bold
                  tracking-tight
                  leading-tight
                  text-white
                "
                >Profroma Date</span
              >
            </label>

            <div class="flex items-center">
              <input
                readonly
                :value="data[i].date.split(' ')[0]"
                type="text"
                class="
                  input input-bordered
                  w-full
                  border-theme-green
                  focusring
                  input-sm
                "
              />
            </div>
          </div>
          <div class="form-control">
            <label class="label">
              <span
                class="
                  label-text
                  font-bold
                  tracking-tight
                  leading-tight
                  text-white
                "
                >Amount</span
              >
            </label>
            <div class="flex items-center">
              <input
                readonly
                :value="data[i].fees"
                type="text"
                class="
                  input input-bordered
                  w-full
                  border-theme-green
                  focusring
                  input-sm
                "
              />
            </div>
          </div>
          <div class="form-control">
            <label class="label">
              <span
                class="
                  label-text
                  font-bold
                  tracking-tight
                  leading-tight
                  text-white
                "
                >C-GST</span
              >
            </label>
            <div class="flex items-center">
              <input
                readonly
                :value="data[i].cgst"
                type="text"
                class="
                  input input-bordered
                  w-full
                  border-theme-green
                  focusring
                  input-sm
                "
              />
            </div>
          </div>
          <div class="form-control">
            <label class="label">
              <span
                class="
                  label-text
                  font-bold
                  tracking-tight
                  leading-tight
                  text-white
                "
                >S-GST</span
              >
            </label>
            <div class="flex items-center">
              <input
                readonly
                :value="data[i].sgst"
                type="text"
                class="
                  input input-bordered
                  w-full
                  border-theme-green
                  focusring
                  input-sm
                "
              />
            </div>
          </div>
          <div class="form-control">
            <label class="label">
              <span
                class="
                  label-text
                  font-bold
                  tracking-tight
                  leading-tight
                  text-white
                "
                >I-GST</span
              >
            </label>
            <div class="flex items-center">
              <input
                readonly
                :value="data[i].igst"
                type="text"
                class="
                  input input-bordered
                  w-full
                  border-theme-green
                  focusring
                  input-sm
                "
              />
            </div>
          </div>
          <div class="form-control">
            <label class="label">
              <span
                class="
                  label-text
                  font-bold
                  tracking-tight
                  leading-tight
                  text-white
                "
                >Gross</span
              >
            </label>
            <div class="flex items-center">
              <input
                readonly
                :value="data[i].gross"
                type="text"
                class="
                  input input-bordered
                  w-full
                  border-theme-green
                  focusring
                  input-sm
                "
              />
            </div>
          </div>
        </div>
        <div class="flex items-center justify-center gap-10 mt-10">
          <button v-if="status === 'Y'" class="btn btn-warning" @click="close">
            Cancel
          </button>
          <button
            v-else
            class="btn btn-warning"
            @click="statusUpdate('N')"
            :disabled="clicked"
          >
            Cancel
          </button>
          <button class="btn btn-info" v-if="status === 'Y'" @click="close">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z"
              />
            </svg>
          </button>
          <button
            v-else
            class="btn btn-info"
            @click="statusUpdate('Y')"
            :disabled="clicked"
          >
            Accept
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Mill Profroma",
  props: [
    "data",
    "i",
    "closeView",
    "statusUpdate",
    "status",
    "close",
    "clicked",
  ],
};
</script>